module.exports = __webpack_public_path__ + "site/img/74.b30476d0.jpg";